import { useRef, useState, useEffect } from "react";

// Éditeur de cadre pour la photo du plat. box = {x,y,width,height} en fraction 0-1.
export default function DishCrop({ url, box, onChange }) {
  const ref = useRef(null);
  const drag = useRef(null);

  const clamp = (v) => Math.max(0, Math.min(1, v));

  const start = (e, mode) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = ref.current.getBoundingClientRect();
    drag.current = { mode, rect, box: { ...box }, px: e.clientX, py: e.clientY };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", end);
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    const dx = (e.clientX - d.px) / d.rect.width;
    const dy = (e.clientY - d.py) / d.rect.height;
    let { x, y, width, height } = d.box;
    if (d.mode === "move") {
      x = clamp(x + dx); y = clamp(y + dy);
      x = Math.min(x, 1 - width); y = Math.min(y, 1 - height);
    } else if (d.mode === "br") {
      width = Math.max(0.05, Math.min(1 - x, width + dx));
      height = Math.max(0.05, Math.min(1 - y, height + dy));
    } else if (d.mode === "tl") {
      const nx = clamp(x + dx), ny = clamp(y + dy);
      width = Math.max(0.05, width + (x - nx)); height = Math.max(0.05, height + (y - ny));
      x = Math.min(nx, x + width - 0.05); y = Math.min(ny, y + height - 0.05);
    }
    onChange({ x, y, width, height });
  };
  const end = () => {
    drag.current = null;
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", end);
  };
  useEffect(() => () => end(), []); // cleanup

  const pct = (n) => `${n * 100}%`;

  return (
    <div ref={ref} className="relative w-full overflow-hidden rounded-2xl select-none" style={{ background: "var(--at-elevated)", touchAction: "none" }} data-testid="dish-crop-editor">
      <img src={url} alt="" className="pointer-events-none block w-full" draggable={false} />
      <div className="pointer-events-none absolute inset-0" style={{ boxShadow: "0 0 0 2000px rgba(0,0,0,0.45)", clipPath: `polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 ${pct(box.y)}, ${pct(box.x)} ${pct(box.y)}, ${pct(box.x)} ${pct(box.y + box.height)}, ${pct(box.x + box.width)} ${pct(box.y + box.height)}, ${pct(box.x + box.width)} ${pct(box.y)}, 0 ${pct(box.y)})` }} />
      <div
        className="absolute cursor-move"
        style={{ left: pct(box.x), top: pct(box.y), width: pct(box.width), height: pct(box.height), border: "2px solid var(--at-brand)", borderRadius: 8 }}
        onPointerDown={(e) => start(e, "move")}
        data-testid="dish-crop-box"
      >
        <span onPointerDown={(e) => start(e, "tl")} className="absolute -left-2 -top-2 h-5 w-5 rounded-full border-2 border-white" style={{ background: "var(--at-brand)" }} data-testid="dish-crop-tl" />
        <span onPointerDown={(e) => start(e, "br")} className="absolute -bottom-2 -right-2 h-5 w-5 rounded-full border-2 border-white" style={{ background: "var(--at-brand)" }} data-testid="dish-crop-br" />
      </div>
    </div>
  );
}
